import "path";
import { readFile } from "fs/promises";
import { h as headToHeadAnalysis } from "../../../../chunks/headToHeadAnalysis.js";
import { g as getForm } from "../../../../chunks/getForm.js";
const games22Path = "src/pulse_past.json";
const filePath = "src/_games.json";
const prerender = false;
const games = JSON.parse(await readFile(filePath, "utf8"));
const games22 = JSON.parse(await readFile(games22Path, "utf8"));
async function load({ fetch, params }) {
  const data = games[params.id] ?? // (await read("/" + path.resolve("./") + "/" + filePath).json())[params.id] ??
  games22[params.id] ?? // ??
  // (await read("/" + path.resolve("./") + "/" + games22Path).json())
  // [
  //   params.id
  // ]
  await (await fetch(
    `https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games/${params.id || ""}.json`
  )).json();
  var headtohead = (
    // fetchNew
    //   ? // Object.values({
    [
      ...Object.values({
        ...games22,
        // ),
        // ...Object.values(
        //   await read("/" + path.resolve("./") + "/" + games22Path).json()
        // ),
        // ...Object.values(
        ...games
      }).filter(
        // ...Object.values(
        //   await read("/" + path.resolve("./") + "/" + filePath).json()
        // )
        // .filter(
        (v, i, l) => v.season != 2023 || v.secondend != void 0 || v.patch_status == "finished"
        //   &&
        // new Date(v.secondend).toISOString() < new Date().toISOString()
      )
    ].filter(
      (v, i, l) => v.id != params.id && new Date(v.start).getTime() < new Date(data.start).getTime() && (v.homeid == data.homeid || v.awayid == data.homeid) && (v.homeid == data.awayid || v.awayid == data.awayid)
    ).map(headToHeadAnalysis)
  );
  headtohead.sort(
    (b, a) => new Date(a.start).getTime() - new Date(b.start).getTime()
  );
  const hometeamform = await getForm(
    // data.homeid,
    data?.homeid,
    params.id,
    // games
    // JSON.parse(JSON.stringify(games))
    structuredClone(games)
  );
  const awayteamform = await getForm(
    data.awayid,
    params.id,
    // games
    // JSON.parse(JSON.stringify(games))
    structuredClone(games)
  );
  return {
    id: params.id,
    match: data,
    headtohead: headtohead.slice(0, 5),
    hometeamform: hometeamform.slice(0, 5),
    awayteamform: awayteamform.slice(0, 5)
  };
}
export {
  load,
  prerender
};
